import { colors } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

export const GraphDescription = ({ children }: PropsWithChildren<unknown>) => (
  <text x={8} y={32} dominantBaseline="middle" style={{ color: colors.textTertiary, fontSize: 10 }}>
    {children}
  </text>
);
